import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import axios from "axios";

import Globais, { logout, validateToken } from "../../components/Globais";

import Alugueis from "../../components/Alugueis";
import TabelaTitulo from "../../components/TabelaLinha";
import TabelaLinha from "../../components/TabelaLinha";
import TabelaLinhaInteresses from "../../components/TabelaLinhaInteresses";
import { Skeleton } from "antd";

const Container = styled.section`
  width: 100%;
  height: 100%;

  display: grid;
  grid-template: 10% 90% / 100%;
`;
const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
`;
const ContainerLista = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  min-width: 20rem;
  overflow: auto;
  grid-template: 10% 90% / auto;
`;
const ContainerTitulo = styled.section`
  width: 100%;
  height: 100%;
  // border: 5px solid green;

  // display: grid;
  // grid-template: 100% / 30% fr;
  // align-items: center;
  // justify-content: center;
  // // flex-direction: column;
  // overflow: hidden;
  // background-color: #fff;
  // opacity: 80%;
`;
const ConteudoLista = styled.div`
  width: 100vw;
  height: 100%;
  // border: 5px solid green;

  // align-items: center;
  // justify-content: center;
  // // flex-direction: column;

  // background-color: #fff;
  // opacity: 80%;
`;
const ConteudoLinha = styled.div`
  width: 100%;
  height: 10%;
  // border: 5px solid green;

  // align-items: center;
  // justify-content: center;
  // // flex-direction: column;
  // overflow: hidden;
  // background-color: #fff;
  // opacity: 80%;
`;

export default function ViewGerenciarInteressesAlugueis() {
  const [interesses, setInteresses] = useState<any | null>([]);
  const [isLoading, setIsLoading] = useState(true);
  const conteudoNovo = [
    "Interessado",
    "Empreendimento",
    "Cidade",
    "Estado",
    "Data Início",
    "Data Fim",
    "Valor Máximo",
  ];

  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();

      const props = {};

      if (Token) {
        if(Token.nda === 0){
          document.location.href = "/sempermissao";
        }else{
          const URL = `${Globais.DOMINIOBACK}/interesse/alugueis/pesquisa`;

          try {
            const response = await axios.post(URL, props, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              setInteresses(response.data);
              setIsLoading(false);
  
              // const alugueis = await response.data.filter((p: any) => {
              //   return p.origem == 0;
              // });
              // setEstado(estadoAdm);
              // cidadeFormData.estadoId = estado[0].id;
            }
          } catch (error) {
            if (error.response.status === 401) {
              logout();
            }
          }
        }
        
       
      }
    };
    fetchToken();
  }, []);

  return (
    <>
    {isLoading ? (
        <Skeleton active />
      ) : (
<Container>
      <ContainerFiltro></ContainerFiltro>
      <ContainerLista>
        <ContainerTitulo>
          <TabelaLinhaInteresses
            tipo={1}
            background={Globais.CorAzulBackGround}
            conteudo={conteudoNovo}
            color={Globais.CorTexto}
          />
          {/* <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Username</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Mark</td>
                <td>Otto</td>
                <td>@mdo</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Jacob</td>
                <td>Thornton</td>
                <td>@fat</td>
              </tr>
              <tr>
                <td>3</td>
                <td colSpan={2}>Larry the Bird</td>
                <td>@twitter</td>
              </tr>
            </tbody>
          </Table> */}
        </ContainerTitulo>
        <ConteudoLista>
          {interesses.map((item: any, index: number) => (
            <ConteudoLinha key={index}>
              <TabelaLinhaInteresses
                tipo={2}
                background={Globais.CorTexto}
                conteudo={item}
                color={Globais.CorAzulBackGround}
              />
            </ConteudoLinha>
          ))}
        </ConteudoLista>
      </ContainerLista>
      {/* <Imagem src={imagemFundo} alt="" />
      <ContainerLista>
        <ContainerTitulo>
          <TituloLista>Períodos a alugar</TituloLista>
        </ContainerTitulo>

        <ListaWrapper>
          <ContainerFiltro></ContainerFiltro>
          <ContainerTituloColunas>
            <Alugueis
              background={Globais.CorAzulBackGround}
              conteudo={conteudoNovo}
            />
          </ContainerTituloColunas>
        </ListaWrapper>
      </ContainerLista> */}
    </Container>
      )};
    </>
    
  );
}
